import React from 'react'
import {
  Title,
  Box,
  Media,
  MediaLeft,
  Icon,
  MediaContent,
  Subtitle,
  // Dropdown,
  // DropdownTrigger,
  // DropdownMenu,
  // DropdownContent,
  // DropdownItem,
  Button
} from 'bloomer'
import Toggle from 'components/Toggle'
import { MqttClientContext } from 'contexts'
import * as speech from 'speech'

import UpdateModuleModal from './modals/UpdateModuleModal'

class Module extends React.Component {
  state = {
    status: undefined,
    loading: false,
    subscribed: false,
    online: false,
    isMenuOpen: false,
    isModalOpen: false,
  }

  commitCommand = (command) => {
    const {status} = this.state
    const {module, mqttClient} = this.props
    this.setState(() => ({loading: true}))

    const topic = `m/${module.identifier}/${command}`
    mqttClient.publish(topic, '1', null, (err) => {
      if (err) {
        // handle error
        return
      }

      this.setState(() => ({
        status: !status,
        loading: false
      }))
    })
  }

  handleChange = (evt) => {
    const {status} = this.state
    const command = status ? '102' : '101'
    this.commitCommand(command)
  }

  handleVoiceCommand = (evt) => {
    this.commitCommand(evt.detail)
  }

  handleOnlineMessage = (topic, message) => {
    const { module } = this.props
    const [prefix, identifier] = topic.split('/')
    if (prefix !== 'm') return

    if (module.identifier === identifier) {
      const { online } = this.state
      const newOnline = message.toString() === '1'

      if (online !== newOnline) {
        this.setState(() => ({online: newOnline}))
      }
    }
  }

  handleInformationMessage = (topic, message) => {
    const { module, room } = this.props
    const [prefix, identifier, type, informationId] = topic.split('/')

    if (prefix !== 'm') return

    if (module.identifier === identifier && type === '1' && informationId === '1') {
      const { status } = this.state
      const newStatus = message.toString() === '1'

      if (status !== newStatus) {
        if (status !== undefined) {
          speech.speak(`O módulo ${module.name} no cômodo ${room.name} agora está ${newStatus ? 'ligado' : 'desligado'}!`)
        }
        this.setState(() => ({status: newStatus}))
      }
    }
  }

  handleMessage = (topic, message) => {
    console.log(topic, message.toString())

    const topicParts = topic.split('/').length
    if (topicParts === 2) {
      this.handleOnlineMessage(topic, message)
    } else if (topicParts === 3) {
      // command
    } else if (topicParts === 4) {
      this.handleInformationMessage(topic, message)
    }
  }

  handleMenuChange = (evt) => {
    this.setState(({isMenuOpen}) => ({
      isMenuOpen: !isMenuOpen
    }))
  }

  subscribe = () => {
    if (this.state.subscribed) return

    const { module, mqttClient } = this.props

    this.setState(() => ({
      subscribed: true
    }), () => {
      mqttClient.subscribe(`m/${module.identifier}/#`, null, (err) => {
        if (err) {
          this.setState(() => ({subscribed: false}))
        } else {
          mqttClient.on('message', this.handleMessage)
        }
      })
    })
  }

  unsubscribe = () => {
    const { module, mqttClient } = this.props
    mqttClient.unsubscribe(`m/${module.identifier}/#`, () => {
      mqttClient.removeListener('message', this.handleMessage)
    })
  }

  componentDidMount() {
    this.subscribe()
    const {module} = this.props
    document.addEventListener(`command:${module.identifier}`, this.handleVoiceCommand)
  }

  componentWillUnmount() {
    this.unsubscribe()
    const {module} = this.props
    document.removeEventListener(`command:${module.identifier}`, this.handleVoiceCommand)
  }

  handleOpenModal = () => {
    this.setState(() => ({
      isModalOpen: true
    }))
  }

  handleCloseModal = () => {
    this.setState(() => ({
      isModalOpen: false
    }))
  }

  render() {
    const { module, refetch } = this.props
    const { status, loading, subscribed, online, isMenuOpen, isModalOpen } = this.state

    let description = status ? 'ligado' : 'desligado'

    if (loading || !subscribed) {
      description = 'carregando'
    }

    if (!online) {
      description = 'desconectado'
    }

    return (
      <React.Fragment>
      <UpdateModuleModal isActive={isModalOpen} module={module} handleClose={this.handleCloseModal} refetch={refetch} />
      <Box style={{opacity: online || isMenuOpen ? 1 : .3}} title={!online ? `${module.name} está desconectado.` : ''}>
        <Media>
          <MediaLeft>
            <Icon isSize="large" className={`fa fa-lightbulb fa-3x`} style={{opacity: status ? 1 : .3, color: status ? '#ffdd57' : 'inherit', textShadow: status ? '0 0 5rem #ffdd57' : ''}} />
          </MediaLeft>
          <MediaContent style={{overflow: "inherit"}}>
            <div>
              <Button isPulled="right" isSize="small" isColor="light" onClick={this.handleOpenModal}>
                <Icon icon="pencil-alt" />
              </Button>
              {/* <Dropdown isPulled="right" isAlign="right" isActive={isMenuOpen}>
                <DropdownTrigger>
                  <Button isSize="small" isColor="light" aria-haspopup="true" aria-controls="dropdown-menu" onClick={this.handleMenuChange}>
                    <Icon icon="ellipsis-v" />
                  </Button>
                </DropdownTrigger>
                <DropdownMenu>
                  <DropdownContent>
                    <DropdownItem href="#">Editar</DropdownItem>
                    <DropdownItem href="#">Arquivar</DropdownItem>
                  </DropdownContent>
                </DropdownMenu>
              </Dropdown> */}
              <Title isSize={5} style={{marginBottom: 10}}>{module.name}</Title>
              <Toggle isPulled="right" icons={false} checked={status || false} onChange={this.handleChange} disabled={loading || !online} />
              <Subtitle isPulled="left" isSize={6} style={{color: '#4a4a4a'}}>{description}</Subtitle>
            </div>
          </MediaContent>
        </Media>
      </Box>
      </React.Fragment>
    )
  }
}

export default (props) => (
  <MqttClientContext.Consumer>
    {({client}) => <Module mqttClient={client} {...props} />}
  </MqttClientContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/pages/DashboardPage/Module.js